/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelectorToStore, useDispatchToStore } from '@hooks/reduxHooks';
import cookies, { eraseCookie } from '@utils/cookies';
import {
  sendOtpOrEmail,
  login,
  resetOtpResponse,
  authenticate,
  fetchMyInfo,
  fetchPurchasedItems
} from '@actions/auth';
import { useRouter } from 'next/router';
import { Spacings } from '../../../styleConstants';
import EnterNumberStep from './EnterNumberStep';
import EnterOtpStep from './EnterOtpStep';

const Wrapper = styled.div`
  grid-column: span 10;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(10, ${Spacings.SPACING_8B});
  grid-column-gap: ${Spacings.SPACING_4B};
  position: relative;
`;

const ENTER_NUMBER_STEP = 1;
const ENTER_OTP_STEP = 2;

const SIGNUP_TYPE = 'signup';
const LOGIN_TYPE = 'login';

const defaultCountry = {
  code: 'IN',
  name: 'India',
  flagIconUrl: 'https://static.uacdn.net/thumbnail/country-flag-icons/in.png',
  phoneCode: '91'
};

const Login = ({ type }) => {
  const { pathname } = useRouter();
  const dispatch = useDispatchToStore();
  const mapStateToProps = ({ auth }) => {
    return {
      otpOrEmailResponse: auth.otpOrEmailData,
      gotoOTPStep: !!auth.otpOrEmailData,
      isRegistered: auth.otpOrEmailData
        ? auth.otpOrEmailData.is_registered
        : false,
      loggingIn: auth.loggingIn
    };
  };
  const props = useSelectorToStore(mapStateToProps);
  const { isRegistered, loggingIn, otpOrEmailResponse, gotoOTPStep } = props;

  const [step, setStep] = useState(ENTER_NUMBER_STEP);
  const [loginType, setLoginType] = useState(
    type === 'signup' ? SIGNUP_TYPE : LOGIN_TYPE
  );
  const [mobileNumber, setMobileNumber] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [otp, setOtp] = useState('');
  const [numberStepErrorMsg, setNumberStepErrorMsg] = useState('');
  const [otpStepErrorMsg, setOtpStepErrorMsg] = useState('');

  const resetErrorMsgs = () => {
    dispatch(resetOtpResponse());
    setNumberStepErrorMsg('');
    setOtpStepErrorMsg('');
  };

  useEffect(() => {
    return () => resetErrorMsgs();
  }, []);

  const switchLoginType = () => {
    resetErrorMsgs();
    if (loginType === SIGNUP_TYPE) {
      setLoginType(LOGIN_TYPE);
    } else {
      setLoginType(SIGNUP_TYPE);
    }
  };

  useEffect(() => {
    if (otpOrEmailResponse) {
      let errorMsg = '';
      if (loginType === SIGNUP_TYPE && isRegistered) {
        errorMsg = 'This phone number is already registered with us.';
      }

      if (loginType === LOGIN_TYPE && !isRegistered) {
        errorMsg = 'This phone number is not registered with us.';
      }

      if (errorMsg === '') {
        setStep(ENTER_OTP_STEP);
      } else {
        setNumberStepErrorMsg(errorMsg);
      }
    }
  }, [isRegistered, loginType, gotoOTPStep]);

  const submitNumber = () => {
    resetErrorMsgs();
    dispatch(sendOtpOrEmail(mobileNumber, 'IN', 1, '', true));
  };

  const resendOtp = (otp_type) => {
    dispatch(sendOtpOrEmail(mobileNumber, 'IN', otp_type, '', true));
  };

  const goBackToFirstStep = (event) => {
    resetErrorMsgs();
    setStep(ENTER_NUMBER_STEP);
    event.preventDefault();
  };

  const { meUid } = useSelectorToStore(({ auth }) => ({
    meUid: auth.me?.uid
  }));

  const postLoginActions = () => {
    dispatch(fetchMyInfo(pathname));
    dispatch(fetchPurchasedItems());
  };

  useEffect(() => {
    if (meUid) {
      window.location.reload();
    }
  }, [meUid]);

  const submitLogin = () => {
    const data = { email, mobileNumber, code };
    const nameArr = name.split(' ');

    dispatch(
      login(
        loginType === LOGIN_TYPE ? '' : data.email,
        data.mobileNumber,
        otp,
        'IN',
        'phone',
        nameArr[0],
        nameArr[1],
        '',
        '',
        !isRegistered,
        true,
        code
      )
    ).then((response) => {
      const loginResponse = response.result;
      if (loginResponse?.access_token) {
        dispatch(authenticate(loginResponse.access_token));
        cookies.setCookie(
          'accessToken',
          loginResponse.access_token,
          3024000,
          true
        );
        eraseCookie('selectedGoalUid');
        postLoginActions();
      } else {
        setOtpStepErrorMsg(response.error.message);
      }
    });
  };

  return (
    <Grid>
      <Wrapper>
        {step === ENTER_NUMBER_STEP ? (
          <EnterNumberStep
            accountType={loginType}
            changeAccountType={switchLoginType}
            country={defaultCountry}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            name={name}
            setName={setName}
            email={email}
            setEmail={setEmail}
            code={code}
            setCode={setCode}
            submitNumber={submitNumber}
            errorMsg={numberStepErrorMsg}
          />
        ) : null}
        {step === ENTER_OTP_STEP ? (
          <EnterOtpStep
            accountType={loginType}
            mobileNumber={mobileNumber}
            country={defaultCountry}
            resendOtp={resendOtp}
            editMobileNumber={goBackToFirstStep}
            otp={otp}
            setOtp={setOtp}
            code={code}
            setCode={setCode}
            otpOrEmailResponse={otpOrEmailResponse}
            submitLogin={submitLogin}
            loggingIn={loggingIn}
            errorMsg={otpStepErrorMsg}
            isRegistered={isRegistered}
          />
        ) : null}
      </Wrapper>
    </Grid>
  );
};

Login.propTypes = {
  type: PropTypes.string.isRequired
};

export default Login;
